var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.zz)?_c('div',{staticClass:"help-center"},[_c('self-service',{attrs:{"zz-sectionid":"1"}}),_c('order-service-section',{attrs:{"zz-sectionid":"2"}}),_c('question-category',{attrs:{"zz-sectionid":"3"}})],1):_c('div',[_c('zz-help-center')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }